import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Image, Header, Icon} from 'semantic-ui-react';

const icon = require('../img/icons/access_denied.svg');

class AccessDenied extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Acceso Denegado - Quipuu</title>
        </Helmet>
        <br/>
        <Header as='h1' icon textAlign='center'>
          <Icon><Image centered src={icon} height={260} alt='logo'/></Icon>
          <Header.Content>
            Acceso Denegado
            <Header.Subheader>
              Lo sentimos no tienes los suficientes permisos para estar en este lugar!
            </Header.Subheader>
          </Header.Content>
        </Header>
      </div>
    );
  }
}

export default AccessDenied;



// WEBPACK FOOTER //
// ./src/containers/AccessDenied.js